<script>
  import { Submenu } from 'element-ui'
  export default {
    name: 'ElSubmenu',
    extends:Submenu
  }
</script>
